import { EGateway } from '@domain/enums/common/EGateway';

export const NUVEM_SHOP_GATEWAYS = [EGateway.MERCADO_PAGO, EGateway.PAG_SEGURO, EGateway.PAGARME];
